import WebApp from '@twa-dev/sdk';

import { isTMA } from './is-tma';

export const showPopup = (...params: Parameters<typeof WebApp.showPopup>) => {
  if (!isTMA()) {
    const [{ title, message, buttons }] = params;

    const text = [title, message].filter(Boolean).join('\n');

    if (!buttons) {
      window.alert(text);
    } else {
      window.confirm(text);
    }

    return;
  }

  const [options] = params;
  WebApp.showPopup(options);
};
